document.addEventListener("DOMContentLoaded", function() {
  const contentBody = document.querySelector('.article-template__content');
  const listContainer = document.getElementById('toc-list');
  const wrapper = document.getElementById('toc-wrapper');

  if (contentBody && listContainer) {
    const headings = contentBody.querySelectorAll('h2, h3');
    
    if (headings.length > 0) {
      headings.forEach((heading, index) => {
        const id = 'heading-' + index;
        heading.setAttribute('id', id);
        
        const li = document.createElement('li');
        const link = document.createElement('a');
        link.href = '#' + id;
        link.textContent = heading.textContent;

        /* 👇 CLOSE TOC WHEN CLICKED */
        link.addEventListener("click", function(){
          wrapper.classList.remove("active");      // close mobile drawer
          wrapper.classList.add("toc-collapsed");  // collapse desktop TOC
        });
        
        if (heading.tagName === 'H3') {
          li.style.paddingLeft = '20px';
          link.style.fontSize = '1.3rem';
        }
        
        li.appendChild(link);
        listContainer.appendChild(li);
      });
    } else {
      wrapper.style.display = 'none';
    }
  }
});
document.addEventListener("DOMContentLoaded", function(){

  const toc = document.getElementById("toc-wrapper");
  const toggle = document.querySelector(".toc-toggle");

  toggle.addEventListener("click", function(){

    toc.classList.toggle("toc-collapsed");

    if(toc.classList.contains("toc-collapsed")){
      toggle.textContent = "Show";
    }else{
      toggle.textContent = "Hide";
    }

  });

});